import React from 'react';

const LogIcon = (props: { size: number | string; mode: 'light' | 'dark' }) => (
  <svg width={props.size} height={props.size} viewBox="0 0 48 48">
    <ellipse
      cx="24"
      cy="24"
      rx="22"
      ry="21"
      fill="none"
      stroke={props.mode === 'dark' ? '#fff' : '#000'}
      strokeWidth="2.6"
      strokeDasharray="10,3"
    />
    <ellipse
      cx="23"
      cy="23.5"
      rx="17"
      ry="16"
      fill="none"
      stroke={props.mode === 'dark' ? '#ddd' : '#333'}
      strokeWidth="1.5"
    />
    <ellipse
      cx="22"
      cy="22.5"
      rx="12"
      ry="11.5"
      fill="none"
      stroke={props.mode === 'dark' ? '#bbb' : '#555'}
      strokeWidth="1.5"
    />
    <ellipse
      cx="21.5"
      cy="22"
      rx="7"
      ry="7"
      fill="none"
      stroke={props.mode === 'dark' ? '#999' : '#777'}
      strokeWidth="1"
    />
    <circle cx="32" cy="16" r="3" fill={props.mode === 'dark' ? '#fff' : '#000'} />
    <circle cx="32" cy="16" r="1.5" fill={props.mode === 'dark' ? '#ddd' : '#333'} />
    <circle cx="21.5" cy="22" r="3" fill={props.mode === 'dark' ? '#fff' : '#000'} />
  </svg>
);

export default LogIcon;
